export const GET_LEADERBOARDS = "GET_LEADERBOARDS"
export const GET_LEADERBOARDS_SUCCESS = "GET_LEADERBOARDS_SUCCESS"
export const GET_LEADERBOARDS_FAILURE = "GET_LEADERBOARDS_FAILURE"
